const otpInput = document.getElementById("otp-input");
const otpSubmitBtn = document.getElementById("otp-form-submit-button");
const otpFormErrorMessage = document.getElementById("otp-form-error-message");
const checkoutNameStorageKey = "yrPendingCheckoutCustomerName";

otpInput.addEventListener("input", (e) => {
  otpSubmitBtn.disabled = e.target.value.length < 4;
  otpFormErrorMessage.innerText = "";
  otpInput.classList.remove("invalid");
});

const otpValidation = (submit) => {
  if (otpInput.value.length < 4) {
    return otpInput.classList.add("invalid");
  }

  submit();
};

otpSubmitBtn.addEventListener("click", () => {
  otpValidation(checkOtp);
});

const checkOtp = async () => {
  otpSubmitBtn.disabled = true;

  const body = {
    phone: phoneNumberInput.value,
    code: otpInput.value,
  };

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-type": "application/json",
    },
  };

  const res = await fetch(
    `${window.location.origin}/apps/yvesrocher/customer/login/attempt`,
    config
  );

  const data = await res.json();
  otpSubmitBtn.disabled = false;

  if (res.ok) {
    login(data.data);
  } else {
    otpFormErrorMessage.innerText = data.data.message;
  }
};

const login = (data) => {
  const { email, password } = data;

  const emailInput = document.getElementById("default-login-email");
  const passwordInput = document.getElementById("default-login-password");
  const form = document.getElementById("customer_login");
  const checkoutUrlInput = form.querySelector('input[name="checkout_url"]');

  emailInput.value = email;
  passwordInput.value = password;

  try {
    const pendingName = JSON.parse(
      sessionStorage.getItem(checkoutNameStorageKey)
    );

    if (
      checkoutUrlInput &&
      pendingName?.firstName &&
      pendingName?.lastName
    ) {
      const previousCheckoutUrl = new URL(
        checkoutUrlInput.value,
        window.location.origin
      );
      const checkoutUrl = new URL("/checkout", window.location.origin);
      ["locale", "preview_theme_id"].forEach((parameter) => {
        const value = previousCheckoutUrl.searchParams.get(parameter);

        if (value) {
          checkoutUrl.searchParams.set(parameter, value);
        }
      });
      checkoutUrl.searchParams.set(
        "checkout[shipping_address][first_name]",
        pendingName.firstName
      );
      checkoutUrl.searchParams.set(
        "checkout[shipping_address][last_name]",
        pendingName.lastName
      );
      checkoutUrlInput.value = `${checkoutUrl.pathname}${checkoutUrl.search}${checkoutUrl.hash}`;
    }
  } catch (error) {
    console.warn("Could not prefill the checkout customer name", error);
  } finally {
    sessionStorage.removeItem(checkoutNameStorageKey);
  }

  form.submit();
};
